var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: _vm.$t("base.penaltyReconciliationStatement"),
        visible: _vm.isShowDeduction,
        top: "5vh",
        width: "660px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShowDeduction = $event
        },
      },
    },
    [
      _c("div", [
        _c("div", { staticClass: "flex-start" }, [
          _c("img", {
            staticStyle: { width: "100px", "margin-right": "20px" },
            attrs: { alt: "logo", src: require("@/assets/ajlogo1.svg") },
          }),
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "20px",
                "font-weight": "bold",
                color: "black",
              },
            },
            [_vm._v(_vm._s(_vm.$t("base.anJunLMPenaltyStatement")))]
          ),
        ]),
        _c(
          "div",
          {
            staticStyle: {
              margin: "10px 0",
              "font-size": "16px",
              "font-weight": "bold",
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("newOrder.BasicInformation")) + " ")]
        ),
        _c("div", [
          _c("div", { staticClass: "info-table" }, [
            _c("div", { staticClass: "info-row" }, [
              _c("div", { staticClass: "info-label" }, [
                _vm._v(_vm._s(_vm.$t("navbar.siteName"))),
              ]),
              _c("div", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.resultData.siteName || "--")),
              ]),
            ]),
            _c("div", { staticClass: "info-row" }, [
              _c("div", { staticClass: "info-label" }, [
                _vm._v(_vm._s(_vm.$t("base.entityName"))),
              ]),
              _c("div", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.resultData.providerBody || "--")),
              ]),
            ]),
            _c("div", { staticClass: "info-row" }, [
              _c("div", { staticClass: "info-label" }, [
                _vm._v(_vm._s(_vm.$t("base.billingMonth"))),
              ]),
              _c("div", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.resultData.billPeriod || "--")),
              ]),
            ]),
          ]),
        ]),
        _c(
          "div",
          {
            staticStyle: {
              margin: "10px 0",
              "font-size": "16px",
              "font-weight": "bold",
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("base.deductionDetails")) + " ")]
        ),
        _c("table", { staticClass: "deduction-table" }, [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("base.deductionItem")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("mdfeTranslate.quantity")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("base.totalDeductionAmount")))]),
            ]),
          ]),
          _c(
            "tbody",
            [
              _vm._l(_vm.resultData.details, function (item, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(item.responsibilityTypeStr))]),
                  _c("td", [_vm._v(_vm._s(item.quantity))]),
                  _c("td", [_vm._v(_vm._s(item.amountStr))]),
                ])
              }),
              _c(
                "tr",
                {
                  staticClass: "empty-row",
                  staticStyle: { height: "35px !important" },
                },
                [_c("td", { attrs: { colspan: "3" } })]
              ),
              _c("tr", { staticClass: "total-row" }, [
                _c("td", [_vm._v(_vm._s(_vm.$t("newOrder.Total")))]),
                _c("td", [_vm._v(_vm._s(_vm.resultData.totalQuantity))]),
                _c("td", [_vm._v(_vm._s(_vm.resultData.totalAmountStr))]),
              ]),
            ],
            2
          ),
        ]),
        _c("div", { staticClass: "tip" }, [
          _c("span", { staticClass: "icon" }, [_vm._v("!")]),
          _vm._v(
            " " +
              _vm._s(_vm.$t("base.deadlineNotice1")) +
              " " +
              _vm._s(_vm.resultData.confirmDeadline) +
              "，" +
              _vm._s(_vm.$t("base.deadlineNotice2")) +
              " "
          ),
        ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.rowData.btn === 1
            ? _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.btnConfirmPenaltyBill },
                },
                [_vm._v(" " + _vm._s(_vm.$t("base.approved")) + " ")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.isShowDeduction = false
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.Close")) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }